
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-c5ek4l",
"minContentWidth": "--awsui-min-content-width-c5ek4l",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-c5ek4l",
"contentGapLeft": "--awsui-content-gap-left-c5ek4l",
"contentGapRight": "--awsui-content-gap-right-c5ek4l",
"contentHeight": "--awsui-content-height-c5ek4l",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-c5ek4l",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-c5ek4l",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-c5ek4l",
"defaultMaxContentWidth": "--awsui-default-max-content-width-c5ek4l",
"defaultMinContentWidth": "--awsui-default-min-content-width-c5ek4l",
"drawerSize": "--awsui-drawer-size-c5ek4l",
"drawerMinSize": "--awsui-drawer-min-size-c5ek4l",
"bottomDrawerSize": "--awsui-bottom-drawer-size-c5ek4l",
"footerHeight": "--awsui-footer-height-c5ek4l",
"headerGap": "--awsui-header-gap-c5ek4l",
"headerHeight": "--awsui-header-height-c5ek4l",
"layoutWidth": "--awsui-layout-width-c5ek4l",
"mainGap": "--awsui-main-gap-c5ek4l",
"mainOffsetLeft": "--awsui-main-offset-left-c5ek4l",
"mainTemplateRows": "--awsui-main-template-rows-c5ek4l",
"mobileBarHeight": "--awsui-mobile-bar-height-c5ek4l",
"notificationsHeight": "--awsui-notifications-height-c5ek4l",
"offsetTop": "--awsui-offset-top-c5ek4l",
"overlapHeight": "--awsui-overlap-height-c5ek4l",
"navigationWidth": "--awsui-navigation-width-c5ek4l",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-c5ek4l",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-c5ek4l",
"splitPanelHeight": "--awsui-split-panel-height-c5ek4l",
"splitPanelMinWidth": "--awsui-split-panel-min-width-c5ek4l",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-c5ek4l",
"toolsMaxWidth": "--awsui-tools-max-width-c5ek4l",
"toolsWidth": "--awsui-tools-width-c5ek4l",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-c5ek4l",
"contentScrollMargin": "--awsui-content-scroll-margin-c5ek4l",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-c5ek4l",
"flashbarStackIndex": "--awsui-flashbar-stack-index-c5ek4l",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-c5ek4l",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-c5ek4l",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-c5ek4l",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-c5ek4l",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-c5ek4l",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-c5ek4l",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-c5ek4l",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-c5ek4l",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-c5ek4l",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-c5ek4l",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-c5ek4l",
"sliderLabelCount": "--awsui-slider-label-count-c5ek4l",
"sliderTickCount": "--awsui-slider-tick-count-c5ek4l",
"sliderReferenceColumn": "--awsui-slider-reference-column-c5ek4l",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-c5ek4l",
"sliderMaxStart": "--awsui-slider-max-start-c5ek4l",
"sliderMinEnd": "--awsui-slider-min-end-c5ek4l",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-c5ek4l",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-c5ek4l",
"togglesLeftWidth": "--awsui-toggles-left-width-c5ek4l",
"togglesRightWidth": "--awsui-toggles-right-width-c5ek4l",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-c5ek4l",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-c5ek4l",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-c5ek4l",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-c5ek4l",
"styleBackgroundActive": "--awsui-style-background-active-c5ek4l",
"styleBackgroundDefault": "--awsui-style-background-default-c5ek4l",
"styleBackgroundDisabled": "--awsui-style-background-disabled-c5ek4l",
"styleBackgroundHover": "--awsui-style-background-hover-c5ek4l",
"styleBorderColorActive": "--awsui-style-border-color-active-c5ek4l",
"styleBorderColorDefault": "--awsui-style-border-color-default-c5ek4l",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-c5ek4l",
"styleBorderColorHover": "--awsui-style-border-color-hover-c5ek4l",
"styleColorActive": "--awsui-style-color-active-c5ek4l",
"styleColorDefault": "--awsui-style-color-default-c5ek4l",
"styleColorDisabled": "--awsui-style-color-disabled-c5ek4l",
"styleColorHover": "--awsui-style-color-hover-c5ek4l",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-c5ek4l",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-c5ek4l",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-c5ek4l",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-c5ek4l",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-c5ek4l",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-c5ek4l",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-c5ek4l",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-c5ek4l",
"styleBackgroundReadonly": "--awsui-style-background-readonly-c5ek4l",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-c5ek4l",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-c5ek4l",
"styleColorReadonly": "--awsui-style-color-readonly-c5ek4l",
"styleBackgroundFocus": "--awsui-style-background-focus-c5ek4l",
"styleBorderColorFocus": "--awsui-style-border-color-focus-c5ek4l",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-c5ek4l",
"styleColorFocus": "--awsui-style-color-focus-c5ek4l",
"stylePlaceholderColor": "--awsui-style-placeholder-color-c5ek4l",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-c5ek4l",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-c5ek4l",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-c5ek4l",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-c5ek4l",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-c5ek4l",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-c5ek4l",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-c5ek4l",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-c5ek4l",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-c5ek4l",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-c5ek4l",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-c5ek4l",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-c5ek4l",
"alertIconColor": "--awsui-alert-icon-color-c5ek4l",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-c5ek4l",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-c5ek4l",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-c5ek4l",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-c5ek4l",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-c5ek4l",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-c5ek4l",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-c5ek4l",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-c5ek4l",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-c5ek4l",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-c5ek4l",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-c5ek4l",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-c5ek4l",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-c5ek4l",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-c5ek4l",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-c5ek4l",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-c5ek4l",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-c5ek4l",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-c5ek4l",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-c5ek4l",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-c5ek4l",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-c5ek4l",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-c5ek4l",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-c5ek4l",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-c5ek4l",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-c5ek4l",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-c5ek4l",
"progressBarHeight": "--awsui-progress-bar-height-c5ek4l",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-c5ek4l",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-c5ek4l",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-c5ek4l",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-c5ek4l",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-c5ek4l",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-c5ek4l",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-c5ek4l",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-c5ek4l",
      };
      export default customCSSPropertiesMap;
    